import { render } from "./ModalShare.vue?vue&type=template&id=36e0880c"
import script from "./ModalShare.vue?vue&type=script&lang=js"
export * from "./ModalShare.vue?vue&type=script&lang=js"

import "./ModalShare.vue?vue&type=style&index=0&id=36e0880c&lang=css"
script.render = render

export default script